var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "doc_sb_edit p-3" },
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_type" } },
            [_vm._v("\n                Тип\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "advanced_type", disabled: "", type: "text" },
              domProps: { value: _vm.typeLabel },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_state" } },
            [_vm._v("\n                Статус\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "advanced_state", disabled: "", type: "text" },
              domProps: { value: _vm.stateLabel },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_created" } },
            [_vm._v("\n                Створено\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "advanced_created", disabled: "", type: "text" },
              domProps: { value: _vm.createdAtLabel },
            }),
          ]),
        ]),
        _vm._v(" "),
        _vm.has_action
          ? _c("div", { staticClass: "list_state mt-4" }, [
              _c("div", { staticClass: "form-group mt-2" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "intro_html" } },
                  [
                    _vm._v(
                      "\n                    План врегулювання\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group flex-nowrap d-block" },
                  [
                    _c("vue-editor", {
                      attrs: { "editor-toolbar": _vm.editor_rules },
                      model: {
                        value: _vm.doc.settlement_plan,
                        callback: function ($$v) {
                          _vm.$set(_vm.doc, "settlement_plan", $$v)
                        },
                        expression: "doc.settlement_plan",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "mt-4 btn btn-primary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_settlement },
                  },
                  [_vm._v("\n                    Зберегти\n                ")]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }